<template>
  <div class="pagina ativa" id="paginaLinks">
    <div class="pagina-titulo" style="display:flex;align-items:center;gap:9px;"><Link2 :size="20" /> Links Uteis</div>
    <div v-if="ehAdmin" style="margin-bottom:20px;">
      <button @click="abrirModal()">+ Adicionar Link</button>
    </div>
    <div>
      <p v-if="carregando" style="color:#aaa;text-align:center;">Carregando...</p>
      <p v-else-if="links.length === 0" style="color:#aaa;text-align:center;">Nenhum link cadastrado.</p>
      <div v-else style="display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:15px;">
        <div v-for="l in links" :key="l.linha" class="card" :style="{ textAlign: 'left', borderLeft: l.perfil === 'admin' ? '4px solid #c0392b' : '4px solid transparent' }">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:6px;">
            <div style="font-weight:bold;color:#4a5c2f;">{{ l.titulo }}</div>
            <span v-if="l.perfil === 'admin'" style="background:#fdecea;color:#c0392b;font-size:10px;font-weight:700;padding:2px 8px;border-radius:10px;text-transform:uppercase;letter-spacing:.03em;white-space:nowrap;">Admin</span>
          </div>
          <div style="font-size:12px;color:#888;margin-bottom:10px;min-height:16px;">{{ l.descricao }}</div>
          <a :href="normalizarUrl(l.url)" target="_blank" rel="noopener" style="font-size:13px;color:#2980b9;word-break:break-all;">{{ l.url }}</a>
          <div v-if="ehAdmin" style="margin-top:10px;display:flex;gap:8px;">
            <button @click="abrirModal(l)" style="padding:6px 12px;font-size:12px;margin-top:0;">Editar</button>
            <button @click="excluir(l.linha)" style="padding:6px 12px;font-size:12px;margin-top:0;background:#c0392b;">Excluir</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="modalAberto" class="app-drawer-overlay">
      <div class="app-drawer">
        <h3>Link</h3>
        <label>TITULO</label>
        <input type="text" v-model="form.titulo" placeholder="Portal do Consorcio" />
        <label>URL</label>
        <input type="text" v-model="form.url" placeholder="https://..." />
        <label>DESCRICAO</label>
        <input type="text" v-model="form.descricao" placeholder="Breve descricao..." />
        <label style="margin-top:8px;">VISIVEL PARA</label>
        <select v-model="form.perfil">
          <option value="todos">Todos (admin + vendedores)</option>
          <option value="admin">Somente Admin</option>
        </select>
        <div class="status">{{ statusModal }}</div>
        <div class="app-drawer-acoes">
          <button @click="modalAberto = false" style="background:#888;">Cancelar</button>
          <button @click="salvar">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, apiDelete, getSession } from '../api'
import { Link2 } from 'lucide-vue-next'

export default {
  name: 'PaginaLinks',
  components: { Link2 },
  data() {
    return {
      links: [],
      carregando: true,
      modalAberto: false,
      statusModal: '',
      form: { linha: null, titulo: '', url: '', descricao: '', perfil: 'todos' }
    }
  },
  computed: {
    ehAdmin() {
      return getSession().perfil === 'admin'
    }
  },
  created() {
    this.carregar()
  },
  methods: {
    normalizarUrl(u) {
      if (!u) return u
      return /^https?:\/\//i.test(u) ? u : 'https://' + u
    },
    async carregar() {
      this.carregando = true
      const r = await apiGet('links/listar')
      if (r.sucesso) this.links = r.links
      this.carregando = false
    },
    abrirModal(link) {
      if (link) this.form = { linha: link.linha, titulo: link.titulo, url: link.url, descricao: link.descricao, perfil: link.perfil }
      else this.form = { linha: null, titulo: '', url: '', descricao: '', perfil: 'todos' }
      this.statusModal = ''
      this.modalAberto = true
    },
    async salvar() {
      if (!this.form.titulo || !this.form.url) { this.statusModal = 'Preencha titulo e URL.'; return }
      const body = { titulo: this.form.titulo, url: this.form.url, descricao: this.form.descricao, perfil: this.form.perfil }
      if (this.form.linha) body.linha = this.form.linha
      const r = await apiPost('links/salvar', body)
      if (r.sucesso) {
        this.modalAberto = false
        this.carregar()
      } else {
        this.statusModal = r.mensagem || 'Erro ao salvar.'
      }
    },
    async excluir(linha) {
      const r = await apiDelete('links/excluir', { linha })
      if (r.sucesso) this.carregar()
    }
  }
}
</script>
